export default function ProjectCard({ project, onOpen }) {
  return (
    <div className="project-card surface" onClick={() => onOpen(project)}>
      <img src={project.image} alt={project.title} />

      <div className="project-overlay">
        <h3>{project.title}</h3>
        <p>{project.short}</p>
      </div>
    </div>
  );
}
